import { BaseModelActive } from '../../../shared/base/base.models';
import { PointOfSale } from '../points-of-sale/points-of-sale.models';
import { Product } from '../products/products.models';
import { Badge } from '../badges/badges.models';

export class OfferedProduct extends BaseModelActive {
    pointOfSale?: PointOfSale | string;
    product?: Product | string;
    regularPrice?: number;
    salePrice?: number;
    discountPercentage?: number;
    affectsMinimumOrderValue?: boolean = true;
    affectsRebateBase?: boolean = true;
    badges?: Badge[] = [];
    amountFrom?: number;
    quantityOnOrders?: number;
    additionalQuantity?: number = 0;
    quantityAvailable?: number;
    erpOfferUpdate?: boolean = false; // if true, moderator can change quantityOnStock
    quantityOnStock?: number;
    quantityOnStockLimitOne?: number = null;
    quantityOnStockLimitTwo?: number = null;
    maxQuantityPerOrder?: number;
    specialTreatment?: boolean = false;
    minimalValue?: number = 0;
    mainImage?: string;
    secondImage?: string;
    // in out for webshop
    saleDetails?: SaleDetails[];
}

export class SaleDetails {
    salePrice?: number;
    discountPercentage?: number;
    amountFrom?: number;
    validTo?: Date;
}
